import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Cookie, X } from 'lucide-react';

export const CookieConsent = () => {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        // Check if user has already accepted/declined cookies
        const consent = localStorage.getItem('cookie-consent');
        if (!consent) {
            // Show banner after a short delay
            setTimeout(() => setShowBanner(true), 1500);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie-consent', 'accepted');
        setShowBanner(false);
    };

    const handleDecline = () => {
        localStorage.setItem('cookie-consent', 'declined');
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-slate-900/95 backdrop-blur-lg border-t border-slate-700 shadow-2xl animate-in slide-in-from-bottom-5">
            <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
                <div className="flex items-start gap-3">
                    <Cookie className="w-6 h-6 text-amber-400 flex-shrink-0 mt-0.5" />
                    <div>
                        <p className="text-sm text-slate-300">
                            We use cookies to enhance your experience, analyze site traffic, and for marketing purposes. 
                            By continuing to use our site, you consent to our use of cookies.{' '}
                            <Link to="/privacy" className="text-indigo-400 hover:text-indigo-300 underline">
                                Learn more
                            </Link>
                        </p>
                    </div>
                </div>
                <div className="flex items-center gap-3 flex-shrink-0">
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={handleDecline}
                        className="border-slate-600 text-slate-300 hover:bg-slate-800"
                    >
                        Decline
                    </Button>
                    <Button
                        size="sm"
                        onClick={handleAccept}
                        className="bg-indigo-600 hover:bg-indigo-700"
                    >
                        Accept Cookies
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
